/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PageResponseListWorkDTO,
  PagedModelWorkDTO,
  PatchDocument,
  WorkDTO,
} from '../models/index';
import {
    PageResponseListWorkDTOFromJSON,
    PageResponseListWorkDTOToJSON,
    PagedModelWorkDTOFromJSON,
    PagedModelWorkDTOToJSON,
    PatchDocumentFromJSON,
    PatchDocumentToJSON,
    WorkDTOFromJSON,
    WorkDTOToJSON,
} from '../models/index';

export interface CreateWorkRequest {
    workDTO: WorkDTO;
}

export interface DeleteWorkRequest {
    workId: number;
}

export interface ExportWorksRequest {
    requestBody: Array<number>;
    size?: number;
    pageNumber?: number;
}

export interface FindByOrcidPutcodeRequest {
    putcode: number;
}

export interface GetImportWorkByCursorRequest {
    size?: number;
    nextPageCursor?: string;
    orderBy?: string;
    direction?: GetImportWorkByCursorDirectionEnum;
    pubtypes?: Array<string>;
    issuedBefore?: number;
    issuedAfter?: number;
    requestBody?: Array<number>;
}

export interface GetWorkRequest {
    workId: number;
}

export interface MergeDuplicatesRequest {
    unicumId: number;
    requestBody: Array<number>;
}

export interface RequestDeleteRequest {
    workId: number;
    patchDocument: Array<PatchDocument>;
}

export interface UpdateWorkRequest {
    workId: number;
    patchDocument: Array<PatchDocument>;
}

/**
 * 
 */
export class WorkApi extends runtime.BaseAPI {

    /**
     * Creates request options for createWork without sending the request
     */
    async createWorkRequestOpts(requestParameters: CreateWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workDTO'] == null) {
            throw new runtime.RequiredError(
                'workDTO',
                'Required parameter "workDTO" was null or undefined when calling createWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkDTOToJSON(requestParameters['workDTO']),
        };
    }

    /**
     */
    async createWorkRaw(requestParameters: CreateWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.createWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async createWork(requestParameters: CreateWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.createWorkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteWork without sending the request
     */
    async deleteWorkRequestOpts(requestParameters: DeleteWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling deleteWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work/{workId}`;
        urlPath = urlPath.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteWorkRaw(requestParameters: DeleteWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteWork(requestParameters: DeleteWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWorkRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for exportWorks without sending the request
     */
    async exportWorksRequestOpts(requestParameters: ExportWorksRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling exportWorks().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work/export`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async exportWorksRaw(requestParameters: ExportWorksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelWorkDTO>> {
        const requestOptions = await this.exportWorksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelWorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async exportWorks(requestParameters: ExportWorksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelWorkDTO> {
        const response = await this.exportWorksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findByOrcidPutcode without sending the request
     */
    async findByOrcidPutcodeRequestOpts(requestParameters: FindByOrcidPutcodeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['putcode'] == null) {
            throw new runtime.RequiredError(
                'putcode',
                'Required parameter "putcode" was null or undefined when calling findByOrcidPutcode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['putcode'] != null) {
            queryParameters['putcode'] = requestParameters['putcode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work/findByOrcidPutcode`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async findByOrcidPutcodeRaw(requestParameters: FindByOrcidPutcodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.findByOrcidPutcodeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async findByOrcidPutcode(requestParameters: FindByOrcidPutcodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.findByOrcidPutcodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getImportWorkByCursor without sending the request
     */
    async getImportWorkByCursorRequestOpts(requestParameters: GetImportWorkByCursorRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['nextPageCursor'] != null) {
            queryParameters['nextPageCursor'] = requestParameters['nextPageCursor'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['pubtypes'] != null) {
            queryParameters['pubtypes'] = requestParameters['pubtypes'];
        }

        if (requestParameters['issuedBefore'] != null) {
            queryParameters['issued_before'] = requestParameters['issuedBefore'];
        }

        if (requestParameters['issuedAfter'] != null) {
            queryParameters['issued_after'] = requestParameters['issuedAfter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work/cursor`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async getImportWorkByCursorRaw(requestParameters: GetImportWorkByCursorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageResponseListWorkDTO>> {
        const requestOptions = await this.getImportWorkByCursorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageResponseListWorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async getImportWorkByCursor(requestParameters: GetImportWorkByCursorRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageResponseListWorkDTO> {
        const response = await this.getImportWorkByCursorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWork without sending the request
     */
    async getWorkRequestOpts(requestParameters: GetWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling getWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work/{workId}`;
        urlPath = urlPath.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWorkRaw(requestParameters: GetWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.getWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async getWork(requestParameters: GetWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.getWorkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mergeDuplicates without sending the request
     */
    async mergeDuplicatesRequestOpts(requestParameters: MergeDuplicatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['unicumId'] == null) {
            throw new runtime.RequiredError(
                'unicumId',
                'Required parameter "unicumId" was null or undefined when calling mergeDuplicates().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling mergeDuplicates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work/merge/{unicumId}`;
        urlPath = urlPath.replace(`{${"unicumId"}}`, encodeURIComponent(String(requestParameters['unicumId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Merges the given duplicate works into the unicum work
     */
    async mergeDuplicatesRaw(requestParameters: MergeDuplicatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.mergeDuplicatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     * Merges the given duplicate works into the unicum work
     */
    async mergeDuplicates(requestParameters: MergeDuplicatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.mergeDuplicatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for requestDelete without sending the request
     */
    async requestDeleteRequestOpts(requestParameters: RequestDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling requestDelete().'
            );
        }

        if (requestParameters['patchDocument'] == null) {
            throw new runtime.RequiredError(
                'patchDocument',
                'Required parameter "patchDocument" was null or undefined when calling requestDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work/{workId}/requestDelete`;
        urlPath = urlPath.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['patchDocument']!.map(PatchDocumentToJSON),
        };
    }

    /**
     */
    async requestDeleteRaw(requestParameters: RequestDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.requestDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async requestDelete(requestParameters: RequestDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.requestDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateWork without sending the request
     */
    async updateWorkRequestOpts(requestParameters: UpdateWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling updateWork().'
            );
        }

        if (requestParameters['patchDocument'] == null) {
            throw new runtime.RequiredError(
                'patchDocument',
                'Required parameter "patchDocument" was null or undefined when calling updateWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/work/{workId}`;
        urlPath = urlPath.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['patchDocument']!.map(PatchDocumentToJSON),
        };
    }

    /**
     */
    async updateWorkRaw(requestParameters: UpdateWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.updateWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async updateWork(requestParameters: UpdateWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.updateWorkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetImportWorkByCursorDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetImportWorkByCursorDirectionEnum = typeof GetImportWorkByCursorDirectionEnum[keyof typeof GetImportWorkByCursorDirectionEnum];
